import { ServerResponse } from 'node:http';

export const normalizeBaseHref = (baseHref: string): string => {
  const raw = (baseHref || '/').trim() || '/';
  const withLeadingSlash = raw.startsWith('/') ? raw : `/${raw}`;
  return withLeadingSlash.endsWith('/')
    ? withLeadingSlash
    : `${withLeadingSlash}/`;
};

export const applyNoStoreCacheHeaders = (res: ServerResponse): void => {
  res.setHeader('Cache-Control', 'no-store, max-age=0');
};

export const applyNoCacheHeaders = (res: ServerResponse): void => {
  res.setHeader('Cache-Control', 'private, no-cache, must-revalidate');
};
